import ProfileState from "../state/ProfileState";
import AuthenticationService from "./AuthenticationService";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import axios from "../axios";

class ProfileService {
    constructor() {
        this.axiosPrivate = useAxiosPrivate();
    }

    register(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`password-register`, payload)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    registerInterestBySlug(slug, payload, authenticated = false) {
        const url = `listings/slug/${slug}/register-interest`;
        if(authenticated) {
            return new Promise((resolve, reject) => {
                this.axiosPrivate
                    .post(url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        } else {
            return new Promise((resolve, reject) => {
                axios
                    .post(url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }

    getProfile(rememberMe = false) {
        return new Promise((resolve, reject) => {
            this.axiosPrivate
            .get(`profile`)
            .then(response => {
              const profile = response.data;
              ProfileState.update(profile);
              if (rememberMe) {
                  ProfileState.setRememberMe();
              }
              resolve(profile);
            })
            .catch(error => {
              ProfileState.clear();
              reject(error);
            });
        });
    }

    getApplications(withListing = true) {
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .get(`profile/applications?listing=${withListing}` )
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    archiveApplication(applicationId) {
        const url = `/profile/applications/${applicationId}/archive`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .patch(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getAppointments() {
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .get(`profile/appointments`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    updateProfileData(payload) {
        return new Promise((resolve, reject) => {
            this.axiosPrivate
            .put('profile', payload)
            .then(() => {
              ProfileState.updateFromForm(payload);
              resolve(true);
            })
            .catch(error => {
              reject(error);
            });
        });
    }

    bookViewingWithoutAuthentication(payload) {
        const url = `application-book-appointment`;
        return new Promise((resolve, reject) => {
            axios
                .post(url, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    bookViewingWithAuthentication(applicationId, payload) {
        const url = `profile/applications/${applicationId}/appointments`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .post(url, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    cancelViewing(appointmentId) {
        const url = `profile/appointments/${appointmentId}/cancel`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .patch(url)
                .then((response) => {
                    resolve(true);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    submitApplicationForm(payload) {
        const url = `profile/assessment`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .post(url, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    saveApplicationForm(payload, existingAssessmentId = null) {
        let url = `/profile/assessment`;
        if(existingAssessmentId) {
            url = `/profile/assessment/${existingAssessmentId}`;
        }

        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .put(url, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    getDraftApplicationForms(listingSlug) {
        const url = `/profile/assessments/draft?listingSlug=${listingSlug}`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getApplicationForm(applicationFormId) {
        const url = `/profile/assessment/${applicationFormId}`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getApplicationForms() {
        const url = `/profile/assessments`;
        return new Promise((resolve, reject) => {
            this.axiosPrivate
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    mapProfileForm(profile) {
        return {
          firstName: profile.firstName,
          lastName: profile.lastName,
          phone: profile.phone
        };
    }

    getProfileForm() {
        return {
          firstName: '',
          lastName: '',
          phone: ''
        };
    }

    getProfilePassword() {
        return {
          currentPassword: '',
          newPassword: '',
          newPasswordConfirmation: ''
        };
    }
}

export default new ProfileService();
